<div class="popup-wrapper">
  <div class="popup-box" (appClickOutside)="closePopup(true)">
    <div class="popup-header">
      <div class="popup-header-title">
        <div class="title-content">
          @if (title) {
            <span class="title-text" title="{{ title }}">{{ title }}</span>
          }
          <ng-content select="[slot='title']"></ng-content>
        </div>
        <a
          href="javascript:void(0)"
          class="close"
          (click)="closePopup(false)"
          id="secondary-popup-close"
        >
        </a>
      </div>
    </div>
    <div class="popup-content">
      <div
        class="popup-data-wrapper"
        [class.without-buttons]="!isActionButtonsAvailable"
      >
        <ng-content></ng-content>
      </div>
      @if (isActionButtonsAvailable) {
        <div class="popup-actions-btns">
          @if (!hideSecondaryButton) {
            <div class="each-btn">
              <a href="javascript:void(0);" (click)="onSecondaryAction()">{{
                secondaryActionName
              }}</a>
            </div>
          }
          <div class="each-btn">
            <a
              href="javascript:void(0);"
              (click)="onPrimaryAction()"
              class="primary"
              id="tour-secondary-popup-primary-btn"
              >{{ primaryActionName }}</a
            >
          </div>
        </div>
      }
    </div>
  </div>
</div>
